/**
 * Opens the Shopify account sheet when triggered from Okemia account links.
 */
(function () {
  async function openShopifyAccount() {
    const accountComponent = document.querySelector('shopify-account');
    if (!accountComponent) return false;

    await customElements.whenDefined('shopify-account');

    const shadowRoot = accountComponent.shadowRoot;
    if (shadowRoot) {
      const button =
        shadowRoot.querySelector('button[popovertarget], button[aria-haspopup]') ??
        shadowRoot.querySelector('button');

      if (button instanceof HTMLElement) {
        button.click();
        return true;
      }
    }

    if (accountComponent instanceof HTMLElement) {
      accountComponent.click();
      return true;
    }

    return false;
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-okemia-open-account]');
    if (!trigger) return;

    event.preventDefault();
    openShopifyAccount();
  });
})();
